<template>
  <div class="search-main">
    <Header/>
    <div class="main-1200-width padding-bottom-40 search_box">
      <p class="search-res-success" v-if="goodsList.length > 0">为您找到 <span class="search-red">"{{search}}"</span> 的相关结果
        <span class="search-red">{{total}}</span> 条：</p>
      <p class="search-res-error" v-if="goodsList.length === 0">抱歉，没有为您找到相关结果！</p>
      <div class="search-list" v-if="goodsList.length > 0">
        <a
          v-for="(item, index) in goodsList"
          :key="index"
          :href="'/GoodsDetail?id=' + item['id']"
          class="search-list-item"
        >
          <img :src="$url.cdn(item['image'])" alt=""/>
          <p class="list-item-title">{{ item["title"] }}</p>
          <p class="list-item-price" v-if="is_login">￥{{ formatPrice(item["price"]) }}</p>
          <p class="list-item-price" v-else>价格：**** <a href="/login">登录后查看</a></p>
        </a>
      </div>
      <el-pagination
        v-if="goodsList.length > 0"
        background
        layout="prev, pager, next"
        :page-size="limit"
        :total="total"
        @current-change="pageChange"
        class="page"
      >
      </el-pagination>
    </div>
    <Footer/>
  </div>
</template>
<script>
  import Header from "@/globalComponents/Header";
  import Footer from "@/globalComponents/Footer";
  import {mapGetters} from "vuex";
  import goodsApi from '@/api/goods'
  export default {
    data() {
      return {
        goodsList: [],
        total    : 0,
        page     : 1,
        limit    : 20,
        search   : "",
      };
    },
    computed: {
      ...mapGetters(['is_login']),
    },
    created() {
      this.search = this.$route.params.search;
      this.getGoodsList();  //step1：商品列表
    },
    methods   : {
      formatPrice(e) {
          return e.length === 1 ? e[0] : e.join('~');
      },
      searchClick(search) {
        this.search = search;
        this.getGoodsList();  //step1：商品列表
      },
      //获取商品内容
      async getGoodsList() {
        let {data} = await goodsApi.list({keyword: this.search, page: this.page, list_rows: this.limit})
        this.goodsList = data.data;
        this.total = data.total;
      },
      pageChange(e) {
        this.page = e;
        this.getGoodsList();
      },
    },
    components: {
      Header,
      Footer
    }
  };
</script>
<style lang="less" scoped>
  @import url("./list.less");
</style>
